"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Common {
    constructor(levelCount) {
        this.levelCount = levelCount;
    }
    // distribute values in reversed order from values to levels
    distributeComposition(questionCounts, hardestLevel, values) {
        let composition = Array(hardestLevel).fill(0);
        let count = 0;
        for (let i = hardestLevel - 1; i >= 0; i--) {
            if (questionCounts[i] === 0) {
                continue;
            }
            composition[i] = values[count];
            count++;
        }
        return composition;
    }
    hardestLevel(questionCounts) {
        for (let i = this.levelCount - 1; i >= 0; i--) {
            if (questionCounts[i] > 0) {
                return i;
            }
        }
        return -1;
    }
    sum(values) {
        return values.reduce((x, y) => x + y, 0);
    }
}
exports.Common = Common;
//# sourceMappingURL=calculation-common.js.map